import { createNgReactBridgeDirective } from '../../react-bridge'
import { ScansApplication } from '../../../components/scans-application/scans-application'

export const scansApplication = createNgReactBridgeDirective(
  'reactScansApplication',
  [],
  ScansApplication,
  []
)
